import jQuery from 'jquery';

declare var YT: any;

// @todo this ready hook function must be moved from here
jQuery().ready(function() {

    tdYoutubePlayers.init();
});



export const tdYoutubePlayers: Record<string, any> = {

    // the part name of the player id (they will be ex 'player_youtube_1', 'player_youtube_1', 'player_youtube_2', ...)
    tdPlayerContainer: 'player_youtube',

    // the internal list
    players: [],


    // the initialization of the youtube list players
    init: function() {

        var jqWrapperPlaylistPlayerYoutube = jQuery( '.td_wrapper_playlist_player_youtube' );

        for ( var i = 0; i < jqWrapperPlaylistPlayerYoutube.length; i++ ) {

            var jqPlayerWrapper = jQuery( jqWrapperPlaylistPlayerYoutube[ i ] ),
                youtubePlayer = tdYoutubePlayers.addPlayer( jqPlayerWrapper),
                playerId = youtubePlayer.tdPlayerContainer;

            jqPlayerWrapper.parent().find( '.td_youtube_control').data( 'player-id', playerId );

            var videoYoutubeElements = jqPlayerWrapper.parent().find( '.td_click_video_youtube');
            for ( var j = 0; j < videoYoutubeElements.length; j++ ) {
                jQuery( videoYoutubeElements[ j ] ).data( 'player-id', playerId );

                if ( j + 1 < videoYoutubeElements.length) {
                    jQuery( videoYoutubeElements[ j ] ).data( 'next-video-id', jQuery(videoYoutubeElements[ j + 1 ] ).data( 'video-id' ) );
                } else {
                    jQuery( videoYoutubeElements[ j ] ).data( 'next-video-id', jQuery(videoYoutubeElements[0]).data( 'video-id' ) );
                }
            }


            if ( '1' == jqPlayerWrapper.data( 'autoplay' ) ) {
                youtubePlayer.autoplay = 1;
            }

            var firstVideo = jqPlayerWrapper.data( 'first-video' );

            if ( '' !== firstVideo ) {
                youtubePlayer.tdPlaylistIdYoutubeVideoRunning = firstVideo;
                youtubePlayer.playVideo( firstVideo );
            }
        }

        //click on a youtube movie
        jQuery( '.td_click_video_youtube' ).click(function(){

            var videoId = jQuery( this ).data( 'video-id' ),
                playerId = jQuery( this ).data( 'player-id' );

            if ( undefined !== playerId && '' !== playerId && undefined !== videoId && '' !== videoId ) {
                tdYoutubePlayers.operatePlayer( playerId, 'play', videoId );
            }
        });



        //click on youtube play control
        jQuery( '.td_youtube_control' ).click(function(){

            var playerId = jQuery( this ).data( 'player-id' );

            if ( undefined !== playerId && '' !== playerId ) {
                if ( jQuery( this ).hasClass( 'td-sp-video-play' ) ){
                    tdYoutubePlayers.operatePlayer( playerId, 'play' );
                } else {
                    tdYoutubePlayers.operatePlayer( playerId, 'pause' );
                }
            }
        });
    },


    addPlayer: function( jqPlayerWrapper ) {

        var containerId = tdYoutubePlayers.tdPlayerContainer + '_' + tdYoutubePlayers.players.length,
            tdPlayer = tdYoutubePlayers.createPlayer( containerId, jqPlayerWrapper );

        tdYoutubePlayers.players.push( tdPlayer );

        return tdPlayer;
    },

    operatePlayer: function( playerId, option, videoId ) {
        for ( var i = 0; i < tdYoutubePlayers.players.length; i++ ) {
            if (tdYoutubePlayers.players[i].tdPlayerContainer == playerId ) {

                var youtubePlayer = tdYoutubePlayers.players[ i ];

                // This status is necessary just for mobile
                youtubePlayer.playStatus();

                if ( 'play' === option ) {

                    youtubePlayer.autoplay = 1;

                    if ( undefined === videoId ) {
                        youtubePlayer.playerPlay();
                    } else {
                        youtubePlayer.playVideo(videoId);
                    }
                } else if ( 'pause' == option ) {
                    tdYoutubePlayers.players[i].playerPause();
                }
                break;
            }
        }
    },


    // create and return the youtube player object
    createPlayer: function( containerId, jqPlayerWrapper ) {

        var youtubePlayer = {

            tdYtPlayer: '',

            tdPlayerContainer: containerId,

            autoplay: 0,

            tdPlaylistIdYoutubeVideoRunning: '',

            jqTDWrapperVideoPlaylist: jqPlayerWrapper.closest( '.td_wrapper_video_playlist' ),

            jqPlayerWrapper: jqPlayerWrapper,

            jqControlPlayer: '',

            _videoId: '',

            playVideo: function( videoId ) {

                youtubePlayer._videoId = videoId;

                if ( 'undefined' === typeof( YT ) || 'undefined' === typeof( YT.Player ) ) {

                    // @ts-ignore
                    window.onYouTubePlayerAPIReady = function () {

                        for ( var i = 0; i < tdYoutubePlayers.players.length; i++ ) {
                            tdYoutubePlayers.players[ i ].loadPlayer( );
                        }
                    };

                    jQuery.getScript('https://www.youtube.com/player_api').done(function( script, textStatus ) {
                        //alert(textStatus);
                    });
                } else {
                    youtubePlayer.loadPlayer( videoId );
                }
            },


            loadPlayer: function (videoId) {

                var videoIdToPlay = youtubePlayer._videoId;

                if ( undefined !== videoId ) {
                    videoIdToPlay = videoId;
                }

                if ( undefined === videoIdToPlay ) {
                    return;
                }

                //container is here in case we need to add multiple players on page
                youtubePlayer.tdPlaylistIdYoutubeVideoRunning = videoIdToPlay;

                var current_video_name = window.td_youtube_list_ids['td_' + youtubePlayer.tdPlaylistIdYoutubeVideoRunning]['title'],
                    current_video_time = window.td_youtube_list_ids['td_' + youtubePlayer.tdPlaylistIdYoutubeVideoRunning]['time'];

                //remove focus from all videos from playlist
                youtubePlayer.jqTDWrapperVideoPlaylist.find( '.td_click_video_youtube' ).removeClass( 'td_video_currently_playing' );

                //add focus class on current playing video
                youtubePlayer.jqTDWrapperVideoPlaylist.find( '.td_' + videoIdToPlay ).addClass( 'td_video_currently_playing' );

                //ading the current video playing title and time to the control area
                youtubePlayer.jqTDWrapperVideoPlaylist.find( '.td_current_video_play_title_youtube' ).html( current_video_name );
                youtubePlayer.jqTDWrapperVideoPlaylist.find( '.td_current_video_play_time_youtube' ).html( current_video_time );

                youtubePlayer.jqPlayerWrapper.html('<div id=' + youtubePlayer.tdPlayerContainer + '></div>');

                youtubePlayer.jqControlPlayer = youtubePlayer.jqTDWrapperVideoPlaylist.find( '.td_youtube_control' );

                youtubePlayer.tdYtPlayer = new YT.Player(youtubePlayer.tdPlayerContainer, {//window.myPlayer = new YT.Player(container, {
                    playerVars: {
                        //modestbranding: 1,
                        //rel: 0,
                        //showinfo: 0,
                        autoplay: youtubePlayer.autoplay
                    },
                    height: '100%',
                    width: '100%',
                    videoId: videoIdToPlay,
                    events: {
                        'onStateChange': youtubePlayer.onPlayerStateChange
                    }
                });
            },


            onPlayerStateChange: function (event) {
                if (event.data === YT.PlayerState.PLAYING) {

                    //add pause to playlist control
                    youtubePlayer.pauseStatus();

                } else if (event.data === YT.PlayerState.ENDED) {

                    youtubePlayer.playStatus();

                    //if a video has ended then make auto play = 1; This is the case when the user set autoplay = 0 but start watching videos
                    youtubePlayer.autoplay = 1;


                    //get the next video
                    var nextVideoId = '',
                        tdVideoCurrentlyPlaying = youtubePlayer.jqTDWrapperVideoPlaylist.find( '.td_video_currently_playing' );

                    if ( tdVideoCurrentlyPlaying.length ) {
                        var nextSibling = jQuery( tdVideoCurrentlyPlaying ).next( '.td_click_video_youtube' );
                        if ( nextSibling.length ) {
                            nextVideoId = jQuery( nextSibling ).data( 'video-id' );
                        }
                        //else {
                        //    var firstSibling = jQuery(tdVideoCurrentlyPlaying).siblings( '.td_click_video_youtube:first' );
                        //    if ( firstSibling.length ) {
                        //        nextVideoId = jQuery( firstSibling ).data( 'video-id' );
                        //    }
                        //}
                    }

                    if ('' !== nextVideoId) {
                        youtubePlayer.playVideo(nextVideoId);
                    }

                } else if (YT.PlayerState.PAUSED) {
                    //add play to playlist control
                    youtubePlayer.playStatus();
                }
            },

            //tdPlaylistYoutubeStopVideo: function () {
            //    youtubePlayer.tdYtPlayer.stopVideo();
            //},

            playerPlay: function () {
                // @ts-ignore
                youtubePlayer.tdYtPlayer.playVideo();
            },

            playerPause: function () {
                // @ts-ignore
                youtubePlayer.tdYtPlayer.pauseVideo();
            },

            playStatus: function() {
                // @ts-ignore
                youtubePlayer.jqControlPlayer.removeClass( 'td-sp-video-pause' ).addClass( 'td-sp-video-play' );
            },

            pauseStatus: function() {
                // @ts-ignore
                youtubePlayer.jqControlPlayer.removeClass( 'td-sp-video-play' ).addClass( 'td-sp-video-pause' );
            }
        };

        return youtubePlayer;
    }
};
